import TableSimpleCell from "ds/components/TableSimple/Cell";
import SpacePath from "components/SpacePath";

import { IntegrationsAwsUsedByTableCellProps } from "./types";

const IntegrationsAwsUsedByTableSpaceCell = ({
  item,
  ...cellProps
}: IntegrationsAwsUsedByTableCellProps) => {
  return (
    <TableSimpleCell {...cellProps}>
      <SpacePath spaceId={item.spaceDetails.id} fallbackName={item.spaceDetails.name} />
    </TableSimpleCell>
  );
};

export default IntegrationsAwsUsedByTableSpaceCell;
